import Message from "./message";
import {useMainStore} from "@/store";

export default class Notification extends Message
{
    add()
    {
        useMainStore().ADD_NOTIFICATION({
            id: this.message.id,
            created_at: Math.round(new Date().getTime() / 1000),
            read_at: null,
            type: this.message.type,
            data: this.message.data,
        });
        this.handle();
    }
}
